import {
  SessionFilter,
  SessionFilterField,
} from '../types/SessionsFilterModel';

export const sessionFilterModelToQueryLang = (filters: SessionFilter[]) => {
  const queryLangFiltersList = filters.reduce((acc: string[], filter) => {
    if (
      filter.field === SessionFilterField.FEEDBACK_SCORE &&
      filter.metric === 'average'
    ) {
      acc.push(
        `and(eq("feedback_key", "${filter.key}"), ${filter.comparator}("avg_feedback_score", ${filter.value}))`
      );
    } else if (filter.field === SessionFilterField.FEEDBACK_SCORE) {
      throw new Error(
        'Not implemented: invalid metric for feedback filter on sessions.'
      );
    } else if (
      filter.field === SessionFilterField.METADATA &&
      typeof filter.value === 'object'
    ) {
      Object.entries(filter.value).forEach(([k, v]) => {
        if (v === '') {
          acc.push(`exists("metadata", "${k}")`);
        } else {
          acc.push(`has("metadata", '${JSON.stringify({ [k]: v })}')`);
        }
      });
    } else if (
      filter.field === SessionFilterField.NAME &&
      typeof filter.value === 'string'
    ) {
      acc.push(`${filter.comparator}("name", "${filter.value}")`);
    } else {
      throw new Error(
        'Not implemented: invalid type of value for metadata filter: expected object'
      );
    }
    return acc;
  }, [] as string[]);
  return queryLangFiltersList.reduce((acc, f) => {
    if (acc === '') {
      return f;
    } else {
      return `and(${f}, ${acc})`;
    }
  }, '');
};
